"use strict";

exports.__esModule = true;
exports.LoggerContext = void 0;
var _LoggerController = require("./LoggerController");
var _Utils = require("../../../Utils");
/**
 * Provides Logger functions to consumers.
 * @component
 */
var LoggerContext = exports.LoggerContext = (0, _Utils.createEnhancedContext)({
  propName: "logger",
  defaultController: _LoggerController.LoggerController
});